export const AUTH_ENDPOINT = "oauth/token";
export const REVOKE_ENDPOINT = "oauth/revoke";
export const FORGOT_PASSWORD_ENDPOINT = "users/password";
export const QUESTIONS_ENDPOINT = "api/v1/questions";
export const LEAD_CARE_MANAGER = "api/v1/lead_care_managers";
export const COMMUNITY_ENGAGEMENTS = "api/v1/community_engagements";
export const OUTREACH_LEADERS = "api/v1/outreach_leaders";
export const OUTREACH_STAFFS = "api/v1/outreach_staffs";
export const MEMBERS = "api/v1/members";
export const USERS = "/api/v1/users";
export const USER_TYPE = `${USERS}/by_type`;
export const SURVEYS = "api/v1/surveys";
export const SURVEY_COMMENTS = "api/v1/comments";
export const SURVEYS_STATS = `${SURVEYS}/survey_stats`;
export const ANSWERS_STATS = `${SURVEYS}/answer_stats`;
export const SURVEY = "api/v1/housing_expenses";
export const TASKS = "api/v1/tasks";
export const SUBMIT_ANSWER = "api/v1/answers";
export const ZIP_CODES = "api/v1/locations/zip_codes";
export const BULK_DELETE = "destroy_bulk";
export const SEND_CONFIRMATION = "send_confirmation";
export const POLICIES = "api/v1/policies";
export const HEALTH_PLANS = "api/v1/health_plans";
export const HOUSING_DATABASES = "api/v1/housing_databases";
export const HOUSING_EXPENSES = "api/v1/housing_expenses";
export const EXPENSE_AUTHORIZATIONS = "api/v1/expense_authorizations";
export const COUNTIES = "api/v1/locations/counties";
export const CITIES = "api/v1/locations/cities";
export const STATES = "api/v1/locations/states";
export const FILE_IMPORT = "api/v1/file_imports";
export const UPLOAD_URL = "upload_url";
export const MEMBERS_EXPORT = "export";
export const RELEASES = "api/v1/releases";
export const ENCOUNTERS = "api/v1/encounters";
export const REFERRALS = "api/v1/members/members_referral";
export const REFERRALS_URL = "api/v1/referrals";
export const TEMPLATES = "api/v1/templates";
export const EXPENSE_CATEGORY = "/api/v1/expense_categories";
export const APPROVAL_CONFIGURATION = "/api/v1/approval_configurations";
export const EXPENSE_SUB_CATEGORY = "/api/v1/expense_sub_categories";
export const HOUSING_EXPENSE_REJECTED = (id) =>
  `/api/v1/housing_expenses/${id}/rejection`;
export const HOUSING_EXPENSE_APPROVAL = (id) =>
  `/api/v1/housing_expenses/${id}/approval_payment`;
export const START_ENCOUNTERS = (id) =>
  `api/v1/community_engagements/${id}/encounter`;
export const ENCOUNTERS_HISTORY = (id) =>
  `api/v1/community_engagements/${id}/encounter_history`;
